function formatLocalizedPoints(value) {
  return Intl.NumberFormat(globalThis.navigator?.language).format(value)
}

export { formatLocalizedPoints }
